import React, { Component } from 'react';
import mail from '../images/mail.svg';

class EmailAddress extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    handleClick(event) {
        event.preventDefault();
        document.location.href = "mailto:" + this.props.emailAddress;
    }

    render() {
        let displayAddress = '';
        if(this.props.emailAddress !== undefined) {
            displayAddress = this.props.emailAddress.replace('@','<span>(at)</span>').replace('.','<span class="displayNone">Some random string</span>.');
        }
        return (
            <div>
                <img src={mail} alt="E-Mail" className="phone" />  <a ref="emailAddress" href={""} className={this.props.classNames} onClick={this.handleClick.bind(this)}><span dangerouslySetInnerHTML={{__html: displayAddress}}></span></a>
            </div>
        );
    }
}

export default EmailAddress;


// WEBPACK FOOTER //
// ./src/components/emailaddress.component.js